import React, { useMemo } from "react";
import classNames from "classnames";
import { CurveArrowIcon } from "@/icons/primary";
import customizeCheckoutFormMainImage from "./images/checkout-form-main-image.png";
import { CursorTextColorIcon } from "@/icons/color-icons";
import { ThankYouEmailIcon } from "@/icons/primary";
import { AdvancedProductBkgIcon } from "@/icons/primary";

export type AdvancedSettingsProps = {
  children: React.ReactNode;
  className?: string;
  type?: "customize-checkout-form" | "thank-you-email";
};

const BASE_CLASSES = [
  "font-sans-serif",
  "rounded-base",
  "bg-white",
  "shadow-sm",
  "flex",
  "flex-col",
  "text-center",
];

export function AdvancedSettings({ children, className, type }: AdvancedSettingsProps) {
  const content = useMemo(() => {
    switch (type) {
      case "customize-checkout-form":
        return (
          <div
            style={{
              height: "437px",
            }}
          >
            <div className='absolute z-0'>
              <AdvancedProductBkgIcon style={{ width: "100%" }} />
            </div>

            <img className='relative z-1' src={customizeCheckoutFormMainImage} alt='' />

            <div>
              <CursorTextColorIcon />
            </div>
            <div className='text-lg font-semibold mt-5'>Collect more Information</div>
            <div className='flex justify-center'>
              <div className='block relative'>
                <div
                  className='absolute'
                  style={{
                    left: -95,
                    bottom: 23,
                  }}
                >
                  <CurveArrowIcon />
                </div>
                <div className='text-sm text-mid-neutral-1 my-5'>
                  Here’s a sample of the checkout form
                </div>
              </div>
            </div>
            <div className='flex justify-center'>{children}</div>
          </div>
        );

      case "thank-you-email":
        return (
          <div
            className={classNames("items-center")}
            style={{
              height: "492px",
            }}
          >
            <div className='absolute z-0'>
              <AdvancedProductBkgIcon style={{ width: "100%" }} />
            </div>

            <div className='relative z-1 mt-9'>
              <ThankYouEmailIcon />
            </div>

            <div style={{ maxWidth: "279px", margin: "auto" }}>{children}</div>
          </div>
        );

      default:
        return <div className='p-8 flex flex-col justify-center items-center'>{children}</div>;
    }
  }, [children]);

  return (
    <div className={classNames(BASE_CLASSES, className)} style={{ maxWidth: "760px" }}>
      {content}
    </div>
  );
}

export default AdvancedSettings;
